// extracted by mini-css-extract-plugin
export default {"main-container":"notifications_main-container__Pt2ep","card":"notifications_card__A4QVW","header-boxed":"notifications_header-boxed__9zo7k"};